import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { ProductPrizeGroupCategoryEnum, RedirectPaymentMethodEnum } from '@/generated/api';
import { creditEdit } from '@/util/Form';

@Component({
    components: AllComponents(),
})
export default class Result extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";

    public mode: "MOVIE" | "ERROR" = "MOVIE";
    public orderHistory: BASEAPI.OrderHistory | null = null;
    public prizeList: BASEAPI.Prize[] = [];
    public orderID: string = "";
    public newCardFlag: boolean = false;

    public async created() {
        await this.init();

    }

    @Watch('$route')
    public async init() {
        this.kurukuru = true;
        if (await this.isLoginRedirect(true)) return;

        let directoryName = this.$route.params.directoryName;
        if(!directoryName){
            this.$router.push("/");
            return;
        }

        this.mode = "MOVIE";

        let query = this.$route.query;
        if (query) {
            if(query.callBack && query.callBack == "false"){
                this.error = '予期せぬエラーが発生しました。<br>決済が完了しましたが、注文が確定していない恐れがあります。<br>お手数ですが、以下よりサポートまでお問合せください。<br><br>▼お問合せ先<br><a href="mailto:support@oshi-challe.jp?subject=【決済エラー】&body=お問い合わせ内容をご記載ください。ご登録情報(お名前、メールアドレス)を入力していただけると、スムーズにご対応が可能です。" class="cmnLink fRed">support@oshi-challe.jp</a>';
                this.mode = "ERROR";
                this.kurukuru = false;
                return;
            }
            if (query.orderID && typeof query.orderID === "string") {
                this.orderID = query.orderID
            }
            if (query.newCardFlag && typeof query.newCardFlag === "string") {
                this.newCardFlag = query.newCardFlag === "true" ? true : false
            }
        }

        if(!this.orderID){
            this.error = '予期せぬエラーが発生しました。<br>決済が完了しましたが、注文が確定していない恐れがあります。<br>お手数ですが、以下よりサポートまでお問合せください。<br><br>▼お問合せ先<br><a href="mailto:support@oshi-challe.jp?subject=【決済エラー】&body=お問い合わせ内容をご記載ください。ご登録情報(お名前、メールアドレス)を入力していただけると、スムーズにご対応が可能です。" class="cmnLink fRed">support@oshi-challe.jp</a>';
            this.mode = "ERROR";
            this.kurukuru = false;
            return;
        }

        let id = Number(this.orderID.substring(this.orderID.indexOf('H') + 1));
        let resOrder = await BASEAPI.OrderHistoryController.getOrderHistoryUsingGET(id).catch(AxiosErrorHandler);
        if (isAxiosError(resOrder)) {
            this.error = "" + resOrder.data;
            this.kurukuru = false;
            this.mode = "ERROR";
            return;
        }
        this.orderHistory = resOrder.data;

        let normalPrizeList: BASEAPI.Prize[] = [];
        let wChancePrizeList: BASEAPI.Prize[] = [];
        let bonusPrizeList: BASEAPI.Prize[] = [];
        this.orderHistory.orderHistoryPrizeList?.forEach(item => {
            for(let i = 0; i < item.count; i++){
                if(item.prize.prizeGroup?.category == "w_chance"){
                    wChancePrizeList.push(item.prize);
                } else if(item.prize.prizeGroup?.category == "bonus"){
                    bonusPrizeList.push(item.prize);
                } else {
                    normalPrizeList.push(item.prize);
                }
            }
        });

        let cloneArray = normalPrizeList;
        for (let i = cloneArray.length - 1; i >= 0; i--) {
            let rand = Math.floor(Math.random() * (i + 1))
            // 配列の要素の順番を入れ替える
            let tmpStorage = cloneArray[i]
            cloneArray[i] = cloneArray[rand]
            cloneArray[rand] = tmpStorage
        }
        normalPrizeList = cloneArray;

        this.prizeList = [];
        this.prizeList = normalPrizeList.concat(bonusPrizeList).concat(wChancePrizeList);

        this.kurukuru = false;
    }

    // 動画
    public video: any = false;
    public firstBtnShow: boolean = true;
    public nextBtnShow: boolean = true;
    public showResult: boolean = false;

    public prize: BASEAPI.Prize | null = null;
    public index: number = 0;
    mounted() {
        // マウントされてからDOMを取得してDataに格納しておく
        this.video = document.querySelector('.el-video');

        let movie = document.getElementById("movie");
        if(movie){
            movie.style.height = window.innerHeight + "px";
        }

    }

    public isPlay() {
        // ボタンを押すとplayを発火
        this.video.play();
        this.firstBtnShow = false;
        this.showResult = false;
        this.prize = this.prizeList[this.index];
        this.index++;
    }

    // 動画終了
    public playEnd(){
        this.showResult = true;
        if(this.prizeList.length > this.index){
            this.nextBtnShow = true;
        } else {
            this.nextBtnShow = false;
        }
    }
}
